// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"styles_loaderContainer__1LRdv","text":"styles_text__oPdUu"};